import * as css from './TicketsTicket.css';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Else, If, Then} from 'react-if';
import Table from '../../../../../../component/newTable/Table';
import useMobile from '../../../../../../hooks/useMobile';
import mobileTicketsRow from '../ticketsRow/mobileTicketsRow/MobileTicketsRow';
import TicketsTableHeader from '../ticketsTableHeader/TicketsTableHeader';
import TicketsChart from '../../../ticketsChart/TicketsChart';
import {useState} from 'react';
import Tickets from '../Tickets';
import TicketRowTicket, {getDiscount} from '../ticketsRow/TicketRowTicket';
import NoTicketsScreen from '../../../../../tickets/components/noTicketsScreen/NoTicketsScreen';
import {IS_NEW_TIMETABLE_UI} from '../../../../../../config/config';

const getTicketsPagePath = (event: {type?: string; eid?: number}) => {
    if(event.type === 'course') {
        return 'courses';
    }
    if(event.type === 'timetable' && event.eid && IS_NEW_TIMETABLE_UI(event.eid)) {
        return 'timetable/tickets';
    }
    return 'tickets';
};

const TicketsTicket = () => {
    const {t} = useTranslation('realtime');
    const navigate = useNavigate();
    const event = useSelector((s: any)=> s.event);
    const {eid} = event;
    const {tickets} = useSelector((s:any) => s.tickets);
    const isMobile = useMobile();
    const [activeIndex, setActiveIndex] = useState(null);

    const handleAddFirstTicket = () => {
        navigate(`/e/${eid}/${getTicketsPagePath(event)}`, {state: {openNewTicket: true}});
    };

    if(!tickets?.length) {
        return (
            <Tickets isEmpty>
                <NoTicketsScreen compact onClick={handleAddFirstTicket}/>
            </Tickets>
        );
    }

    const sortTickets   = tickets.slice().sort((a, b) => b.sold - a.sold);
    const showTickets = sortTickets.length > 4 ? sortTickets.slice(0, 3) : sortTickets;
    const moreTickets = sortTickets.length > 4 ? sortTickets.slice(3, sortTickets.length) : null;

    if(moreTickets){
        const moreTicketsInfo = moreTickets ? moreTickets.reduce((item, ticket) => {
            item.amount += ticket.amount;
            item.totalPrice += ((ticket.amount ?? 0) * (ticket.price ?? 0 ));
            item.unsoldPrice += (((ticket.amount ?? 0) - (ticket.sold ?? 0)) * (ticket.price ?? 0 ));
            item.sold += ticket.sold || 0;
            item.soldPrice += ticket.soldPrice || 0;
            item.color = ticket.color;
            item.prices = [...item.prices, ...ticket.prices];
            item.discount += getDiscount(ticket) || 0;
            return item;
        }, {amount: 0, totalPrice:0, unsoldPrice:0, sold: 0, left: 0, soldPrice: 0, color: '', prices: [], discount: 0}) : {amount: 0, totalPrice:0, unsoldPrice:0, sold: 0, left: 0, soldPrice: 0, color: '', price: [], discount: 0};
        moreTicketsInfo.title = t('moreTickets');
        moreTicketsInfo.isMoreTickets = true;
        moreTicketsInfo.eid = eid;
        showTickets.push(moreTicketsInfo);
    }

    return (
        <Tickets>
            <TicketsChart tickets={sortTickets} activeIndex={activeIndex} setActiveIndex={setActiveIndex}/>
            <css.tableTickets className={'free-color'}>
                <TicketsTableHeader />
                <Table
                    list={sortTickets?.map((ticket,index) => (
                        {
                            comp: isMobile ? mobileTicketsRow : TicketRowTicket,
                            props: {ticket,active:activeIndex===index,index,setActiveIndex},
                            key: ticket.tid
                        })
                    )}
                    searchProps={false} checked={undefined} buttonsChildren={undefined}/>
            </css.tableTickets>
        </Tickets>

    );
};

export default TicketsTicket;
